// ==================== PastLeavesModal.jsx ====================
import React, { useEffect, useState } from "react";
import "../Styling/PastLeavesModal.css";
import { X } from "lucide-react";
import { Base_URL } from "../url";
import { createPortal } from "react-dom";


const PastLeavesModal = ({ userId, onClose }) => {
  const [pastLeaves, setPastLeaves] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPastLeaves = async () => {
      try {
        const res = await fetch(
          `${Base_URL}/Leave/past-leaves/${userId}`
        );
        const result = await res.json();

        if (res.ok) {
          setPastLeaves(result.data || []);
        }
      } catch (err) {
        console.error("Error fetching past leaves", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPastLeaves();
  }, [userId]);

  const formatDateRange = (start, end) => {
    const options = { month: "short", day: "numeric" };
    const s = new Date(start).toLocaleDateString("en-US", options);
    if (!end || start === end) return s;
    const e = new Date(end).toLocaleDateString("en-US", options);
    return `${s} – ${e}`;
  };

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header-pastleaves">
          <h3>Past Leaves (This Year)</h3>
          <X className="close-icon" onClick={onClose} />
        </div>
  
        <div className="modal-body-pastleaves">
          {loading ? (
            <div className="empty">Loading...</div>
          ) : pastLeaves.length > 0 ? (
            pastLeaves.map((leave, i) => (
              <div className="past-leave-row" key={i}>
                <span className="type">{leave.leaveType}</span>
                <span className="dates">
                  {formatDateRange(leave.startDate, leave.endDate)}
                </span>
                <span className="days">{leave.days}d</span>
                <span className={`status ${leave.status.toLowerCase()}`}>
                  {leave.status}
                </span>
              </div>
            ))
          ) : (
            <div className="empty">No past leaves found</div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
  
};

export default PastLeavesModal;